import React, { Dispatch, SetStateAction } from "react";
import SubscribeSwiper from "@components/swiper/SubscribeSwiper";

type Props = {
  tab: number;
  setTab: Dispatch<SetStateAction<number>>;
};
const SubscribeTabTwo = ({ tab, setTab }: Props) => {
  return <SubscribeSwiper tab={tab} setTab={setTab} />;
};

export default SubscribeTabTwo;
